import Vue from 'vue';
import axios from 'axios';
import '../../../../filters';
import moment from 'moment';
import { FormWizard, TabContent } from 'vue-form-wizard';

import { validationMixin } from 'vuelidate';
import {
  required,
  email,
  minLength,
  maxLength,
  between
} from 'vuelidate/lib/validators';

export default {
  name: 'CaptureSewerConnection',
  mixins: [validationMixin],
  components: {
    TabContent,
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,

      connDate: null
    }
  },
  validations: {
    
  },
  computed: {

  },
  watch: {
    connDate: function (val) {
      this.dataObj.item.date = moment(val, "DD/MM/YYYY").add(1, 'days');
    }
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('capture_sewer_connection_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.connDate = moment(this.dataObj.item.date).format('DD/MM/YYYY');
      });
    },
    validateAppData() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        return true;
      }
      else {
        return false;
      }
    },
  },
  
}

